import { stock } from '@/data/stockImages';

// Adım adım (S). Hedef: qr menü nasıl oluşturulur, qr menü hazırlama, kafe/restoran için qr menü.
export default [
  {
    t: 'p',
    text: 'QR menü (dijital menü) oluşturmanın iki yolu var. Birincisi, hazır menünüzün PDF’ini ya da görselini internete yükleyip bir QR kod oluşturucuyla o bağlantıya kod üretmek. İkincisi, ürünlerinizi bir QR menü ya da otomasyon yazılımına tek tek girmek; yazılım menü sayfasını ve QR kodu sizin için oluşturur. İlk yol birkaç dakikada biter; ikinci yol biraz daha emek ister ama fiyat değiştiğinde menüyü baştan hazırlamanız gerekmez.',
  },
  {
    t: 'p',
    text: 'Aşağıda her iki yolun farkını, hazırlık listesini ve adımları anlatıyoruz. Kafe ve restoran için dikkat edilecek noktalar yazının sonunda ayrı başlıkta.',
  },
  { t: 'h2', text: 'PDF menü mü, yazılımla hazırlanan menü mü?' },
  {
    t: 'table',
    head: ['', 'PDF / görsel menü', 'Yazılımla hazırlanan menü'],
    rows: [
      ['Hazırlık süresi', 'Kısa; mevcut tasarım kullanılır', 'Ürünlerin tek tek girilmesi gerekir'],
      [
        'Fiyat değişikliği',
        'Dosya yeniden hazırlanıp yüklenir',
        'Ürün fiyatı panelden değişir, menü anında güncellenir',
      ],
      [
        'Telefonda okuma',
        'Yakınlaştırma gerekir, büyük dosya yavaş açılır',
        'Ekrana göre düzenlenir, kategori ve arama olur',
      ],
      ['İçerik ve alerjen', 'Tasarıma sığdığı kadar', 'Ürün bazında gösterilir, filtrelenebilir'],
      ['Masadan sipariş', 'Yok', 'Yazılım destekliyorsa açılabilir'],
    ],
  },
  {
    t: 'p',
    text: 'Menünüz nadiren değişiyor ve yalnızca fiyat göstermek istiyorsanız PDF yeterli olabilir. Fiyatları sık güncelliyorsanız ya da müşterinin menüden sipariş vermesini istiyorsanız yazılımla hazırlanan menü uzun vadede daha az iş çıkarır.',
  },
  { t: 'h2', text: 'Başlamadan önce hazırlanması gerekenler' },
  {
    t: 'img',
    img: stock('qr-menu-el', 'Elde tutulan telefonda açık QR menü'),
  },
  {
    t: 'list',
    items: [
      '**Kategori yapısı:** Sıcak içecekler, soğuk içecekler, tatlılar gibi müşterinin aradığını kolay bulacağı gruplar. Çok fazla kategori, menüde gezinmeyi zorlaştırır.',
      '**Ürün adları ve fiyatlar:** Menüdeki adlar kasadaki adlarla aynı olursa karışıklık azalır.',
      '**Fotoğraflar:** Her ürün için şart değil, ama çok satan ve açıklaması zor ürünlerde işe yarar. Aynı ışık ve açıyla çekilmiş fotoğraflar menüyü daha düzenli gösterir.',
      '**Açıklama, içerik ve alerjen bilgisi:** Özellikle yemeklerde müşterinin en çok sorduğu bilgiler bunlar.',
      '**Masa numaraları:** Menüden sipariş alacaksanız her masanın net bir numarası olmalı.',
    ],
  },
  { t: 'h2', text: 'QR menü oluşturma adımları' },
  {
    t: 'steps',
    items: [
      {
        title: 'Kategorileri oluşturun',
        text: 'Menünüzdeki grupları yazılıma girin. Sıralamayı müşterinin sipariş verme sırasına göre düşünün: kafede önce içecekler, restoranda önce başlangıçlar.',
      },
      {
        title: 'Ürünleri fiyat ve görselleriyle ekleyin',
        text: 'Her ürünün adını, fiyatını, kategorisini ve varsa fotoğrafını girin. Açıklamayı kısa tutun; müşteri menüyü ayakta ya da sohbet ederken okur.',
      },
      {
        title: 'Menüde görünecekleri seçin',
        text: 'Mevsimlik ya da geçici olarak satılmayan ürünleri silmek yerine menüden gizleyin. Tekrar satışa girdiğinde yeniden girmeniz gerekmez.',
      },
      {
        title: 'Menüyü telefonda kontrol edin',
        text: 'Menüyü müşterinin gözünden açın. Uzun ürün adlarının taşıp taşmadığına, fotoğrafların doğru ürünle eşleştiğine ve fiyatların doğruluğuna bakın.',
      },
      {
        title: 'QR kodu indirip bastırın',
        text: 'Tek bir kod tüm masalarda kullanılabilir. Menüden sipariş alacaksanız her masaya ayrı kod bastırmak, masa numarasının otomatik tanınmasını sağlar.',
      },
      {
        title: 'Masalara yerleştirip test edin',
        text: 'Kodu farklı marka telefonlarla, akşam ışığında da okutun. Parlak laminasyon ışığı yansıtıp okumayı zorlaştırabilir; mat yüzey daha rahat okunur.',
      },
    ],
  },
  { t: 'h2', text: 'Tilki Otomasyon’da QR menü oluşturma' },
  {
    t: 'p',
    text: 'Tilki’de QR menü için ayrı bir hazırlık yapmazsınız: panelde “Ürünler” sayfasına eklediğiniz ürünler menüde otomatik görünür. Ürünün fiyatını ve KDV oranını girip alttaki anahtarlarla menüde gösterilip gösterilmeyeceğini, içerik ve kalori bilgisinin görünürlüğünü seçersiniz.',
  },
  {
    t: 'guide',
    image: '10-urun-fiyat',
    alt: 'Ürün düzenleme ekranında fiyat, KDV ve menüde gösterme anahtarları',
    caption: 'Ürün ayarları: fiyat, KDV ve menüde görünürlük.',
  },
  {
    t: 'p',
    text: '“QR Menü” sayfasından kodu indirip bastırabilirsiniz. Müşterilerin menüden sipariş verebilmesini istiyorsanız aynı sayfadaki “Masadan Sipariş Ayarları”ndan online siparişi açmanız yeterli. Menüden gelen siparişler, personel onaylayana kadar işleme girmez.',
  },
  {
    t: 'guide',
    image: '16-qr-ayarlari',
    alt: 'QR menü sayfasında QR kod indirme ve masadan sipariş ayarları',
    caption: 'QR Menü sayfası: kodu indirme ve online sipariş ayarı.',
  },
  {
    t: 'p',
    text: 'Müşteri kodu okuttuğunda ürünleri kategorilere göre görür; arama yapabilir, popüler, alerjensiz ve alkolsüz ürünleri filtreleyebilir. Masadan siparişin tamamını [QR kodla sipariş adımlarında](/nasil-kullanilir#qr-menu) ekran görüntüleriyle anlattık.',
  },
  {
    t: 'guide',
    image: '17-qr-menu',
    alt: 'Müşterinin telefonunda açılan QR menü',
    caption: 'Müşterinin gördüğü menü.',
  },
  { t: 'h2', text: 'Kafe için QR menü hazırlarken' },
  {
    t: 'p',
    text: 'Kafe menüleri kısa ama çeşitlidir. Aynı içeceğin sıcak ve soğuk hâli, farklı süt seçenekleri ya da şurup eklemeleri menüyü kalabalıklaştırabilir. Bu seçenekleri ayrı ürün olarak girmek yerine ürün açıklamasında belirtmek, menüyü kısa tutar. Vitrin ürünleri (kek, kurabiye) gün içinde bittiğinde menüden gizlemek, müşterinin olmayan bir ürünü sipariş etmesini önler.',
  },
  { t: 'h2', text: 'Restoran için QR menü hazırlarken' },
  {
    t: 'p',
    text: 'Restoran menülerinde ürün sayısı ve açıklama uzunluğu artar. Burada öne çıkan konu içerik ve alerjen bilgisidir; müşteri garsona sormadan menüden bakabildiğinde servis hızlanır. Porsiyonu, pişirme şeklini ve yanında gelenleri açıklamada yazmak soru sayısını azaltır. Uzun menülerde kategori sayısını makul tutmak ve en çok satan ürünleri kategorinin başına almak, müşterinin karar vermesini kolaylaştırır.',
  },
  {
    t: 'note',
    title: 'Fiyat listesi düzenlemesi',
    text: 'Ekim 2025’te Fiyat Etiketi Yönetmeliği’nde yapılan değişiklikle (Resmî Gazete, 11.10.2025, sayı 33044) lokanta, kafe ve benzeri işletmelerde fiyat listesinin masalarda karekodla sunulmasına açıkça imkân tanındı. Müşteri talep ettiğinde basılı menü verilmesi ve işyeri girişinde fiyat listesi bulundurulması gerekiyor. Ayrıntılar için [bu özet](https://ozay.av.tr/publication/fiyat-etiketi-yonetmeligi-nde-yapilan-onemli-degisiklikler) incelenebilir; işletmenize özel durumlar için güncel mevzuatı kontrol edin.',
  },
  { t: 'h2', text: 'Sık yapılan hatalar' },
  {
    t: 'list',
    items: [
      '**Çok küçük basılmış kod:** Masada birkaç santimetrenin altına inen kodlar, özellikle eski telefonlarda zor okunur.',
      '**Güncellenmeyen PDF:** Fiyat değiştiği halde eski dosyanın kalması, kasada tartışmaya yol açar.',
      '**Sağlayıcıya bağlı bağlantı:** Kod, hizmetini bıraktığınız bir sağlayıcının adresine yönleniyorsa masalardaki tüm kodları yeniden bastırmanız gerekir.',
      '**İnternet sorunu:** Mekânda mobil çekim zayıfsa misafir Wi-Fi bilgisini QR kodun yanına yazmak işe yarar.',
    ],
  },
  {
    t: 'p',
    text: 'QR menünün işletmeye neler kattığını daha geniş bir çerçevede görmek isterseniz [kafe ve restoran otomasyon sistemi nedir](/blog/kafe-restoran-otomasyon-sistemi-nedir) yazısına göz atabilirsiniz.',
  },
  {
    t: 'cta',
    title: 'QR menünüzü birlikte kuralım',
    text: 'Ücretsiz demo talep edin; ürünlerinizi girip QR kodunuzu hazırlamanıza yardımcı olalım.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'QR menü ücretsiz oluşturulabilir mi?',
    a: 'Evet. Menünüzün PDF’ini internete yükleyip ücretsiz bir QR kod oluşturucuyla kod üretebilirsiniz. Ancak bu yöntemde fiyat değiştikçe dosyayı yeniden hazırlamanız gerekir; masadan sipariş, arama ya da alerjen filtresi gibi özellikler olmaz.',
  },
  {
    q: 'Statik ve dinamik QR kod arasındaki fark nedir?',
    a: 'Statik QR kod, bağlantının kendisini içerir; bağlantı değişirse kod da değişir ve yeniden basılması gerekir. Dinamik QR kod ise sağlayıcının yönettiği bir yönlendirme adresini içerir; hedefi sonradan değiştirebilirsiniz, ama sağlayıcıyı bıraktığınızda kod çalışmayı durdurabilir.',
  },
  {
    q: 'QR kod ne büyüklükte basılmalı?',
    a: 'Masa üstünde okunacak kodlar için birkaç santimetrelik bir kare çoğu telefonda rahat okunur. Kesin ölçüden çok, kodu masadaki okuma mesafesinde farklı telefonlarla denemek daha güvenilir sonuç verir.',
  },
];
